import { Link } from "react-router-dom";
import { leakEntries } from "@/mocks/leaks";

export default function Ticker() {
  const items = leakEntries.slice(0, 6);
  const loop = [...items, ...items];

  return (
    <div className="w-full overflow-hidden border-y border-background-50/10 bg-foreground-950">
      <div className="flex items-stretch">
        <div className="z-10 flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-3 md:px-6">
          <span className="lamp-pulse flex h-2 w-2 rounded-full bg-background-50" />
          <span className="font-label text-xs font-bold tracking-[0.2em] text-background-50">
            线报速递
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker items-center gap-8 py-3 pl-6">
            {loop.map((entry, index) => (
              <Link
                key={`${entry.id}-${index}`}
                to={`/leaks/${entry.id}`}
                className="flex shrink-0 items-center gap-2 font-label text-xs text-background-300 transition-colors hover:text-accent-300 md:text-sm"
              >
                <span className="text-accent-500">◆</span>
                <span className="max-w-[260px] truncate md:max-w-none">{entry.title}</span>
                <span className="text-background-600">{entry.date}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}